import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import { type InstanceDetailDataType } from '@/api/organization';
import { CopyToClipboardTextArea } from '@/components/Form';
import { FieldLabel } from '@/components/Form/fields';
import { Panel } from '@/components/panels';
import { Text } from '@/components/typography';

type Props = {
  instance: InstanceDetailDataType;
};

const CompanySettingsTag = ({ instance }: Props) => {
  return (
    <Panel title={t`Channel99 Tag`}>
      <div className="flex flex-col gap-x-10 gap-y-6 lg:flex-row">
        <div className="w-full lg:w-[41.67%] xl:w-[37.5%] 2xl:w-[33.33%]">
          <div className="flex flex-col gap-2">
            <FieldLabel>
              <Trans>Instructions</Trans>
            </FieldLabel>
            <Text variant="body1">
              <Trans>To install the C99 tag:</Trans>
            </Text>
          </div>
          <ol
            className="mt-2 ps-5 marker:font-sans marker:text-base marker:leading-5 marker:font-normal"
            type="1"
          >
            <li>
              <Text variant="body1">
                <Trans>Log in to your Google Tag Manager account</Trans>
              </Text>
            </li>
            <li>
              <Text variant="body1">
                <Trans>Go to Tags -&gt; Tag Configuration -&gt; Custom HTML</Trans>
              </Text>
            </li>
            <li>
              <Text variant="body1">
                <Trans>Copy the following script with your C99 Token</Trans>
              </Text>
            </li>
            <li>
              <Text variant="body1">
                <Trans>Set tag to "Triggering" and choose "All Pages"</Trans>
              </Text>
            </li>
            <li>
              <Text variant="body1">
                <Trans>Click Submit (upper right)</Trans>
              </Text>
            </li>
          </ol>
        </div>
        <div className="w-full min-w-0 lg:flex-1">
          <div className="flex flex-col gap-2">
            <FieldLabel>
              <Trans>Channel99 Tag (Copy and Place)</Trans>
            </FieldLabel>
            <CopyToClipboardTextArea
              value={`<script async id="tagserver" src="${import.meta.env.VITE_TAG_BASE_URL}/api/v1/fire/snippet?domain=${instance.domain}&token=${instance.code}"></script>`}
            />
          </div>
        </div>
      </div>
    </Panel>
  );
};

export default CompanySettingsTag;
